import 'core-js/features/array/find'
import 'core-js/features/array/find-index'
import 'core-js/es'
import {config} from '../constants/config'
import {
  TYPE_PLAYER,
  TYPE_POC, TYPE_WHW,
} from "../constants/types"

export const addPlayer = (index, cardsCount) => {
  const cards = [];
  let i = 0;
  for (i; i < cardsCount; ++i) {
    cards.push(false)
  }

  return {
    id: index,
    playerName: 'Player ' + index,
    hand: cards,
  };
};

export const changePlayersCount = (currentPlayers, count, cardsCount) => {
  const currentPlayersCount = currentPlayers.length;
  const positiveCount = Math.abs(count);
  let i = 0;
  if (count > 0) {
    for (i; i < positiveCount; ++i) {
      currentPlayers.push(addPlayer(currentPlayersCount + i + 1, cardsCount))
    }
  } else {
    currentPlayers.splice(currentPlayersCount + count, positiveCount)
  }

  return currentPlayers
};

export const addSettingsPlayer = (index, active) => {
  return {
    name: index + ' players',
    id: index,
    active: active
  };
};

export const setPlayersSettings = (minPlayers, maxPlayers, currentPlayers) => {
  const players = [];
  let i = 0;
  for (i; i < maxPlayers - 1; ++i) {
    players.push(addSettingsPlayer(minPlayers + i, false))
  }
  if (currentPlayers <= maxPlayers && currentPlayers >= minPlayers) {
    players.find(player => player.id === currentPlayers).active = true;
  } else {
    players[0].active = true;
  }

  return players
};

export const getBoardData = (count, cardsCount, tableData) => {
  return {
    players: changePlayersCount([], count, cardsCount),
    table: tableData,
    winner: false,
    activeField: {
      type: TYPE_PLAYER,
      id: 0,
      card: {
        type: TYPE_PLAYER,
        id: 0,
      }
    },
  }
};

export const getCalculator = () => {
  return config.calculators.find(calculator => calculator.id === 'poc');//(process.env.REACT_APP_CALCULATOR_TYPE || TYPE_WHW || TYPE_POC));
};

export const getGame = () => {
  return getCalculator().games.find(game => game.active);
};

export const getTableData = (cardsCount) => {
  const tableData = {};
  switch (cardsCount) {
    case 5:
      tableData.flop = [false, false, false];
      tableData.turn = false;
      tableData.river = false;
      break;
    case 4:
      tableData.flop = [false, false, false];
      tableData.turn = false;
      break;
    case 3:
      tableData.flop = [false, false, false];
      break;
    case 2:
      tableData.flop = [false, false];
      break;
    case 1:
      tableData.flop = [false];
      break;
    default:
      break;
  }

  return tableData;
};

export const getGamesSettings = () => {
  return getCalculator().games
};

export const getCards = (cardsData) => {
  return cardsData.suits.map((suit) => {
    return cardsData.ranks.map((rank) => {
      return {
        rank,
        suit,
        active: false,
      }
    });
  })
};
